/**
 * `/studio/mockups/<ref>` — the route (session 48). By ref alone: a mockup ref names its own
 * client, so a task that mentions one can link here.
 */

import { isRef } from '@fareast/shared'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { NotFound } from '../../../errors/NotFound.js'
import { StudioMockupPage } from '../../../pages/mockups/StudioMockupPage.js'

export const Route = createFileRoute('/studio/mockups/$ref')({
  beforeLoad: ({ params }) => {
    if (!isRef('mockup', params.ref)) throw notFound()
  },
  notFoundComponent: NotFound,
  component: StudioMockupRoute,
})

function StudioMockupRoute() {
  const { ref } = Route.useParams()
  return <StudioMockupPage mockupRef={ref} />
}
